(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/api-caller/assets/javascripts/api-caller.js') >= 0) return;  svs.modules.push('/components/tur/api-caller/assets/javascripts/api-caller.js');

'use strict';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const METHOD_GET = 'GET';
const METHOD_POST = 'POST';
const METHOD_PUT = 'PUT';
const METHOD_PATCH = 'PATCH';
const LOGGER_NAME = 'tur:api-caller';
const CONSUMERS = {
  DRAW_GAMES: 'DrawGames',
  ACCOUNT_SERVICES: 'AccountServices',
  TICKET_GAMES: 'TicketGames'
};
let logger;
let migratedFeatures;
let jupiter;
let svsFetch;
if (svs.isServer) {
  var _trinidadCore$config$;
  const trinidadCore = require('@svenskaspelab/trinidad-core').core;
  logger = trinidadCore.logger(LOGGER_NAME);
  migratedFeatures = ((_trinidadCore$config$ = trinidadCore.config.options) === null || _trinidadCore$config$ === void 0 || (_trinidadCore$config$ = _trinidadCore$config$.apiCaller) === null || _trinidadCore$config$ === void 0 ? void 0 : _trinidadCore$config$.migratedFeatures) || {};
  jupiter = trinidadCore.jupiter;
  svsFetch = trinidadCore.svsFetch;
} else {
  var _svs$tur$apiCaller$da;
  logger = new svs.core.log.Logger(LOGGER_NAME);
  migratedFeatures = ((_svs$tur$apiCaller$da = svs.tur.apiCaller.data) === null || _svs$tur$apiCaller$da === void 0 ? void 0 : _svs$tur$apiCaller$da.migratedFeatures) || {};
  jupiter = svs.core.jupiter;
  svsFetch = svs.core.svsFetch;
}
const isMigrated = consumerName => {
  const features = migratedFeatures[consumerName] || [];
  return featureName => features.includes(featureName);
};
const callJupiter = async _ref => {
  let req = _ref.req,
    _ref$method = _ref.method,
    method = _ref$method === void 0 ? METHOD_GET : _ref$method,
    path = _ref.path,
    data = _ref.data,
    successCB = _ref.successCB,
    errorCB = _ref.errorCB;
  if (successCB) {
    logger.debug("Jupiter with callbacks. Method: ".concat(method, " Path: ").concat(path), req);
    return jupiter.call({
      req,
      method,
      path,
      data
    }, successCB, errorCB);
  }
  logger.debug("Jupiter async. Method: ".concat(method, " Path: ").concat(path), req);
  return await jupiter.callAsync({
    req,
    method,
    path,
    data
  });
};

const callElza = async _ref2 => {
  let req = _ref2.req,
    _ref2$method = _ref2.method,
    method = _ref2$method === void 0 ? METHOD_GET : _ref2$method,
    path = _ref2.path,
    data = _ref2.data,
    useCredentials = _ref2.useCredentials,
    successCB = _ref2.successCB,
    errorCB = _ref2.errorCB;
  if (!(path !== null && path !== void 0 && path.length)) {
    logger.error('Elza path is null or empty');
  }
  let fetch;
  if (svs.isServer) {
    fetch = svsFetch(req);
  } else {
    fetch = svsFetch.create();
  }
  const fetchOptions = {
    method
  };

  if (useCredentials && !svs.isServer) {
    fetchOptions.credentials = 'include';
  }

  if (method === METHOD_POST || method === METHOD_PUT || method === METHOD_PATCH) {
    fetchOptions.headers = {
      'Content-Type': 'application/json'
    };
    fetchOptions.body = JSON.stringify({
      data
    });
  }
  const response = await fetch(path, fetchOptions);
  if (!response.ok) {
    throw new Error("Elza request failed: ".concat(response.status, " ").concat(response.statusText));
  }
  return await response.json();
};
const generateApiCallers = () => {
  const apiCallers = {};
  let apiMap;
  if (svs.isServer) {
    apiMap = require('./api-map.es6').apiMap;
  } else {
    apiMap = svs.tur.apiCaller.apiMap;
  }
  Object.keys(apiMap).forEach(fnName => {
    const _apiMap$fnName = apiMap[fnName],
      jupiterPath = _apiMap$fnName.jupiterPath,
      elzaPath = _apiMap$fnName.elzaPath,
      method = _apiMap$fnName.method,
      useCredentials = _apiMap$fnName.useCredentials;
    apiCallers[fnName] = async function (consumerName) {
      const pathParamValues = [];
      let options = {
        successCB: null,
        errorCB: null
      };
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }
      args.forEach(arg => {
        if (typeof arg === 'object' && arg !== null && !Array.isArray(arg)) {
          options = _objectSpread(_objectSpread({}, options), arg);
        } else {
          pathParamValues.push(arg);
        }
      });

      const migrated = isMigrated(consumerName)(fnName);
      const apiCaller = migrated ? callElza : callJupiter;
      const pathFunction = migrated ? elzaPath : jupiterPath;

      const pathFunctionArgs = _objectSpread(_objectSpread({}, options), {}, {
        version: options.version || '1'
      });
      const pathString = pathFunction(pathFunctionArgs);
      const _options = options,
        successCB = _options.successCB,
        errorCB = _options.errorCB,
        data = _options.data,
        req = _options.req;
      return apiCaller({
        req,
        method,
        path: pathString,
        data,
        useCredentials,
        successCB,
        errorCB
      });
    };
  });
  return apiCallers;
};
const INTERNAL_API_CALLER = generateApiCallers();
const createApiCaller = consumerName => {
  const proxy = new Proxy(INTERNAL_API_CALLER, {
    get(target, prop) {
      if (typeof target[prop] === 'function') {
        return function () {
          logger.debug("".concat(prop, " called by ").concat(consumerName));
          for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
            args[_key2] = arguments[_key2];
          }
          return target[prop](consumerName, ...args);
        };
      }
      return target[prop];
    }
  });
  return _objectSpread({
    isMigrated: isMigrated(consumerName)
  }, proxy);
};
if (svs.isServer) {
  module.exports = {
    drawgames: createApiCaller(CONSUMERS.DRAW_GAMES),
    accountservices: createApiCaller(CONSUMERS.ACCOUNT_SERVICES),
    ticketgames: createApiCaller(CONSUMERS.TICKET_GAMES)
  };
} else {
  setGlobal('svs.tur.apiCaller.drawgames', createApiCaller(CONSUMERS.DRAW_GAMES));
  setGlobal('svs.tur.apiCaller.accountservices', createApiCaller(CONSUMERS.ACCOUNT_SERVICES));
  setGlobal('svs.tur.apiCaller.ticketgames', createApiCaller(CONSUMERS.TICKET_GAMES));
}

 })(window);